import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'
import { ApiTaRe290 } from '~/endpoints/ApiTaRe290'

// State types
interface ResultsInfo {
  results: {
    largePartNo: string
    smallPartNo: string
    difficultyLevel: string
    allocation: string
    score: string
    averageScore: string
  }[]
}
const getEmptyResultInfo = (): ResultsInfo => ({
  results: [
    {
      largePartNo: '',
      smallPartNo: '',
      difficultyLevel: '',
      allocation: '',
      score: '',
      averageScore: '',
    },
  ],
})

// State action parameter
interface ActionParamResultsInfo {
  subjectCode: string
  grade: number
  fiscalYear: number
  testMonth: number
  testCountPerMonth?: number
  courseId: string
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/DiagnoseSchoolSubject',
})
export default class DiagnoseSchoolSubject extends VuexModule {
  // State
  private Results_ = getEmptyResultInfo()

  // Getter: resultgetter
  get results(): ResultsInfo {
    return this.Results_
  }

  // Mutations
  @Mutation
  updateResults(values: ResultsInfo) {
    this.Results_ = values
  }

  // Actions

  @Action
  clear() {
    this.context.commit('updateResults', getEmptyResultInfo())
  }

  @Action
  async getResultsInfo(param: ActionParamResultsInfo) {
    logger.trace('in: getResultsInfo')
    const api = new ApiTaRe290.Api()

    const request: ApiTaRe290.Get.Request = {
      query: {
        subjectCode: param.subjectCode,
        grade: param.grade,
        fiscalYear: param.fiscalYear,
        testMonth: param.testMonth,
        courseId: param.courseId,
      },
    }
    if (param.testCountPerMonth) {
      request.query.testCountPerMonth = param.testCountPerMonth
    }
    // API: ApiTaRe290
    const result = await api.get<ResultsInfo | null>(
      request,
      // success
      (data, _) => {
        return {
          results: data.results,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateResults', result)
  }
}
